<template>
  <div style="width: 100%;height:100%;display: flex;justify-content: center;align-items: center;flex-direction: column">
    <img :src="coding" style="width: 400px;height: 400px;margin-top: 18vh;">
    <div style="font-weight: 500;font-size: 20px;">聊天模块</div>
    <div style="font-weight: 500;font-size: 18px;margin-top: 10px;">火速开发中，敬请期待</div>
  </div>
</template>


<script setup>
import coding from "@/assets/coding/coding.gif"

</script>


<style lang="less" scoped>

</style>